/* eslint-disable */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloudIcon from '../../assets/UploadIcon';
import Theme from '../ui/Theme';
import { ErrorToast } from '../utils/Utils';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  btnStyle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    alignItems: 'center',
    color: Theme.palette.primary.main,
  },
}));

export default function VideoUploadButton({ setVideoFile, setVideoUrl, name = 'ashish' }) {
  const classes = useStyles();

  const handleVideoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== 'video/mp4') {
      ErrorToast('Only MP4 videos are allowed');
      return;
    }
    setVideoFile(file);
    setVideoUrl(URL.createObjectURL(file));
  };

  return (
    <div className={classes.root}>
      <input
        name={name}
        accept="video/mp4"
        className={classes.input}
        id="upload-video"
        onChange={handleVideoUpload}
        type="file"
      />
      <label htmlFor="upload-video">
        <Button
          startIcon={<CloudIcon />}
          variant="contained"
          style={{ height: '24px', background: 'white' }}
          disableElevation
          component="span"
        >
          <div className={classes.btnStyle}>Upload Video</div>
        </Button>
      </label>
    </div>
  );
}
